import { ResetPasswordService } from "@app/core/user/domain/services/reset-password.service";
import { Observable } from "rxjs";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Injectable } from "@angular/core";

/**
 * Web service used to reset password.
 */
@Injectable({
  providedIn: "root",
})
export class ResetPasswordWS implements ResetPasswordService {
  constructor(private handler: BaseHandler) {}

  execute(email: string): Observable<void> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.RESET_PASSWORD_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody({
        email: email,
      })
      .build();

    return this.handler.execute(parameters);
  }
}
